import Logo from './img/aiforbi_without_logo.png';
import { FaRegCopyright } from 'react-icons/fa6';
import './css/style.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div id='footer' className='row justify-content-center m-0'>
      <div className='reduced-row d-flex'>
        <div className='navbar-logo'>
          <img src={Logo} alt='Accenture' />
        </div>
        <div className='copyrights'>
          <FaRegCopyright /> {currentYear} Accenture. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Footer;
